import React from "react";

const columns = [
  { id: "todo", title: "To do" },
  { id: "in_progress", title: "In progress" },
  { id: "done", title: "Done" },
];

const priorityOptions = ["low", "medium", "high", "urgent"];

const TaskEditPanel = ({
  selectedTask,
  detailForm,
  employees,
  isUpdating,
  isDeleting,
  onChange,
  onSubmit,
  onDelete,
  onCancel,
}) => (
  <form className="panel form-panel task-form-panel" onSubmit={onSubmit}>
    <div className="task-form-panel__header">
      <div>
        <small className="eyebrow">Update task</small>
        <h3>{selectedTask ? "Edit selected task" : "Select a task from the board"}</h3>
      </div>
      <div className="task-form-panel__actions">
        <button className="secondary-button" type="submit" disabled={!selectedTask || isUpdating}>
          {isUpdating ? "Updating..." : "Save changes"}
        </button>
        <button
          className="table-action table-action--danger"
          type="button"
          disabled={!selectedTask || isDeleting}
          onClick={onDelete}
        >
          {isDeleting ? "Deleting..." : "Delete"}
        </button>
      </div>
    </div>

    <input
      value={detailForm.title}
      onChange={(event) => onChange("title", event.target.value)}
      placeholder="Detailed task title"
      disabled={!selectedTask}
    />
    <textarea
      rows="4"
      value={detailForm.description}
      onChange={(event) => onChange("description", event.target.value)}
      placeholder="Description, next step, or notes"
      disabled={!selectedTask}
    />
    <div className="form-row task-form-grid">
      <select value={detailForm.status} onChange={(event) => onChange("status", event.target.value)} disabled={!selectedTask}>
        {columns.map((column) => (
          <option key={column.id} value={column.id}>{column.title}</option>
        ))}
      </select>
      <select value={detailForm.priority} onChange={(event) => onChange("priority", event.target.value)} disabled={!selectedTask}>
        {priorityOptions.map((priority) => (
          <option key={priority} value={priority}>{priority}</option>
        ))}
      </select>
      <select value={detailForm.assignee_id} onChange={(event) => onChange("assignee_id", event.target.value)} disabled={!selectedTask}>
        <option value="">Unassigned</option>
        {(employees?.data || []).map((employee) => (
          <option key={employee.id} value={employee.id}>
            {employee.first_name} {employee.last_name}
          </option>
        ))}
      </select>
      <input
        type="date"
        value={detailForm.due_date}
        onChange={(event) => onChange("due_date", event.target.value)}
        disabled={!selectedTask}
      />
    </div>

    <div className="orders-form-actions">
      <button className="primary-button" type="submit" disabled={!selectedTask || isUpdating}>
        {isUpdating ? "Updating..." : "Save task"}
      </button>
      <button className="secondary-button" type="button" onClick={onCancel}>
        Back to tasks
      </button>
    </div>
  </form>
);

export default TaskEditPanel;
